export default __webpack_public_path__ + "static/media/color03.ab2201cd.png";